module.exports = __webpack_public_path__ + "static/img/p-21.bd7993e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-21.png
// module id = 987/
// module chunks = 0